module.exports = __webpack_public_path__ + "static/media/occasion-birthdays.9a83dc0e.png";